module.exports = __webpack_public_path__ + "img/services-shape1.d4378059.png";